export const barChartDataDashboard = [
  {
    name: "مبيعات",
    data: [330, 250, 110, 300, 490, 350, 270, 130, 425],
  },
];
